const config = {
    // Environment-based API URLs
    API_BASE_URL: process.env.REACT_APP_API_URL || 'https://stagingadminapi.welliemd.com/api/v1',
    
    
    // Default configuration
    DEFAULT_CLIENT_ID: process.env.REACT_APP_CLIENT_ID || '9de86355-59a6-4c52-b134-124826c0c64e',
    
    // Session configuration
    SESSION_TIMEOUT: 30 * 60 * 1000, // 30 minutes in milliseconds
    
    // UI configuration
    THEME: {
      primary: '#007bff',
      secondary: '#6c757d',
      success: '#28a745',
      danger: '#dc3545',
      warning: '#ffc107',
      light: '#f8f9fa',
      dark: '#343a40'
    },
    
    // Iframe security settings
    IFRAME_SETTINGS: {
      allowedDomains: [
        'localhost',
        '*.welliemd.com',
        '*.wordpress.com',
        '*.wp.com'
      ]
    }
  };
  
  export default config;
  